import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useCustomization } from "../../customization";

export const useSignatureCost = () => {
  const { requirements } = useCustomization();
  const itemCost = requirements?.Signature?.itemCost;

  if (!itemCost) return undefined;

  const amount = formatMoney(itemCost, "USD").replace(/\.00$/, "");
  return { amount, perSignature: `${amount} per signature` };
};
